import { handleOpenReport } from "@/utils";
import { ObtemRelatorioResponse } from "../../shared";
import { Session } from "@/lib/curio/Session";

const CONSULTA_CAIXAS_ABERTAS = {
  USE_CASE_ID: "2702",
  RM_OBTEM_CAIXAS_ABERTAS: "RM_OBTEM_CAIXAS_ABERTAS"
};

export const handleConsultOpenedBoxes = async (session: Session | undefined) => {
  if (!session) {
    console.error("No session available for use case action.");
    return;
  }

  const uc = await session.openUseCase(CONSULTA_CAIXAS_ABERTAS.USE_CASE_ID);
  try {
    const result: ObtemRelatorioResponse = await uc.sendRequest(CONSULTA_CAIXAS_ABERTAS.RM_OBTEM_CAIXAS_ABERTAS);
    const uri = result.URIRelatorio._;
    await handleOpenReport(uri);
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Erro ao Obter Relatório Caixas Abertas.");
  } finally {
    uc.abort();
  }
};
